<template>
  <div>
    <div class="c-textarea c-textarea--no-transition c-rap-textarea">
      <label class="c-textarea__label c-rap-textarea__label" :for="id">
        {{ question.label }}
        <span v-if="question.mandatory" class="c-form-textfield__required">
          *</span
        >
      </label>
      <div
        class="c-rte"
        v-if="question.helpText"
        v-html="question.helpText"
      ></div>
      <validation-message
        :valid="touched && !isInvalid"
        :invalid="touched && isInvalid"
        :validationMessage="validationMessage"
      >
        <textarea
          class="c-textarea__field c-rap-textarea__field"
          rows="10"
          cols="50"
          maxlength="500"
          :id="id"
          :name="name"
          :class="{ 'c-form-textarea__control--is-invalid': isInvalid }"
          v-model="value"
          @blur="onBlur"
          @focus="onFocus"
          @keyup="onKeyUp"
        />
      </validation-message>
      <div class="c-rap-rte" v-if="question.text" v-html="question.text"></div>

      <div class="c-textarea-box__actions" v-if="!isSubmitted">
        <button
          type="button"
          class="c-button c-button--brand c-action-buttons__button"
          @click="handleClick"
        >
          {{ question.buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import ValidationMessage from "../../../../base/validation-message/ValidationMessage.vue";
  import { toSafeKey } from "../../_contact-us-rap/_vue/utils/toSafeKey";
  export default {
    components: {
      ValidationMessage,
    },
    props: {
      index: {
        required: true,
        type: Number,
      },
      question: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        hasFocused: false,
        isSubmitted: false,
        value: "",
        touched: false,
      };
    },
    destroyed() {
      this.value = "";
      this.question.answer = "";
      this.question.answerLabel = "";
      this.touched = false;
    },
    computed: {
      id() {
        return toSafeKey(this.question.label)
      },
      name() {
        return toSafeKey(this.question.label).replace(/-([a-z])/g, (_, c) => c.toUpperCase());
      },
      isInvalid() {
        return this.question.mandatory === true && this.value === "";
      },
      validationMessage() {
        const showValidationMessage = this.touched && this.isInvalid;
        return showValidationMessage ? this.question.validation : null;
      },
    },
    watch: {
      "question.answerLabel"(newVal) {
        if (newVal === "") {
          this.value = "";
          this.isSubmitted = false;
        }
      },
    },
    methods: {
      onBlur() {
        this.hasFocused = false;
      },
      onKeyUp() {
          this.emitInputEvent(null);
          this.isSubmitted = false;
          this.hasFocused = true;
      },
      onFocus() {
        if (!this.hasFocused) {
          this.emitInputEvent(null);
          this.isSubmitted = false;
          this.hasFocused = true;
        }
      },

      handleClick() {
        this.touched = true;
        this.isSubmitted = true;
        this.hasFocused = false;
        this.emitInputEvent(this.question.nextId);
      },

      emitInputEvent(nextId) {
        this.$emit(
          "input",
          this.value,
          this.index,
          this.question.id,
          nextId,
          this.question.final,
          this.question.upload
        );
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/_contact-us-rap/_vue/TextareaBox.vue